let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5GwtU")).then(() => parcelRequire('7b5A1'));